import {  Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import SideNav from './components/layouts/SideNav';
import { Outlet } from 'react-router-dom';
import HeaderJifu from './components/Header/Header';
import './jifu.component.css'
const JifuAcademy = () => {
    return (
        <VStack flexDir='row' alignItems='flex-start' justifyContent='flex-start'h="100%" >
            {/* Side bar */}
            <Stack height='100%' bg="transparent" className='side-nav'>
                    <SideNav/>
            </Stack>
            {/*  */}
            <Stack  position='relative' bg="transparent" top="-7px" className='content-box'>
                <HeaderJifu/>
                <Outlet />
            </Stack>
        </VStack>
    );
};

export default JifuAcademy;